export const ADD_AFFILIATION_FORM_IDENTIFIER =
  'app/containers/AffiliationsFormPage/AddAffiliationForm';
export const EDIT_AFFILIATION_FORM_IDENTIFIER =
  'app/containers/AffiliationsFormPage/EditAffiliationForm';

export const INIT = 'app/containers/AffiliationsFormPage/INIT';
export const INIT_SUCCESS = 'app/containers/AffiliationsFormPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/containers/AffiliationsFormPage/INIT_FAILED';

export const SUBMIT = 'app/containers/AffiliationsFormPage/SUBMIT';
export const SUBMIT_SUCCESS = 'app/containers/AffiliationsFormPage/SUBMIT_SUCCESS';
export const SUBMIT_FAILED = 'app/containers/AffiliationsFormPage/SUBMIT_FAILED';
